module.exports = __webpack_public_path__ + "img/message-question.28cf77b4.svg";